'use client';

import { usePathname, useRouter } from 'next/navigation';
import React, { useState } from 'react';

import { ListingCardsScreenWrapper } from '@website/components/ListingCardsScreenWrapper/ListingCardsScreenWrapper';

interface ClientActivitiesSectionProps {
  activities: Array<{
    id: string;
    title: string;
    imageUrl: string;
    professionalName: string;
    isAtHome?: boolean;
    bookingsSinceLastYear: number;
    /** `null`/`undefined` → no priced slot yet; price block is hidden. */
    startingPrice?: number | null;
    /** Either `city` or `location.address` is forwarded as the venue label. */
    city?: string;
    location?: { address?: string } | null;
  }>;
  className?: string;
}

export function ClientActivitiesSection({ activities, className = '' }: ClientActivitiesSectionProps) {
  const router = useRouter();
  const pathname = usePathname();
  const locale = pathname.split('/')[1]; // Extract locale from current path

  // State for hover/selection
  const [hoveredActivityId, setHoveredActivityId] = useState<string | undefined>(undefined);

  // We don't need to handle translations - the ListingCardsScreenWrapper component
  // already handles this internally

  const handleActivityHover = (activityId: string) => {
    setHoveredActivityId(activityId);
  };

  const handleActivityLeaveHover = () => {
    setHoveredActivityId(undefined);
  };

  const handleActivitySelect = (activityId: string) => {
    console.log(`Activity ${activityId} selected`);
    router.push(`/${locale}/activity/${activityId}`);
  };

  // Note: The ListingCardsScreenWrapper handles these navigations internally
  // We don't need to pass them as props

  return (
    <div className={`w-full ${className}`}>
      {/* Hide "X Activities found" text in professional profile */}
      <ListingCardsScreenWrapper
        activities={activities}
        totalCount={activities.length}
        isLoading={false}
        isError={false}
        showActivityCount={false}
        hideInstructor={true}
        onActivityHover={handleActivityHover}
        onActivityLeaveHover={handleActivityLeaveHover}
        hoveredActivityId={hoveredActivityId}
        onActivitySelect={handleActivitySelect}
      />
    </div>
  );
}
